export default "__VITE_ASSET__BLLuPTUy__"